import React from 'react';
import { Newspaper } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-container border-t border-[#E5E5E5] dark:border-gray-800 bg-[#F8F9FA] dark:bg-gray-900 mt-auto w-full transition-colors duration-300">
            <div className="w-full px-8 py-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-[#D0021B] rounded-lg shadow-lg shadow-[#D0021B]/20">
                            <Newspaper className="w-5 h-5 text-white" />
                        </div>
                        <div>
                            <h3 className="font-serif text-lg text-[#1A1A1A] dark:text-gray-100 font-bold">Press ID Management</h3>
                            <p className="text-[10px] text-[#666666] dark:text-gray-400 tracking-[0.2em] uppercase font-bold">Official Management Portal</p>
                        </div>
                    </div>

                    <div className="flex flex-col items-center md:items-end gap-2">
                        <p className="text-sm text-[#666666] dark:text-gray-400 font-medium">
                            &copy; {currentYear} Press ID Management. All rights reserved.
                        </p>
                        <div className="flex items-center gap-6 text-[11px] font-bold text-[#999999] dark:text-gray-500 uppercase tracking-widest">
                            <Link to="/privacy" className="hover:text-[#D0021B] dark:hover:text-[#FF4D4D] transition-colors">Privacy Policy</Link>
                            <span className="w-1 h-1 bg-gray-300 dark:bg-gray-700 rounded-full"></span>
                            <Link to="/terms" className="hover:text-[#D0021B] dark:hover:text-[#FF4D4D] transition-colors">Terms of Service</Link>
                            <span className="w-1 h-1 bg-gray-300 dark:bg-gray-700 rounded-full"></span>
                            <Link to="/support" className="hover:text-[#D0021B] dark:hover:text-[#FF4D4D] transition-colors">Support</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

